import React from "react";
import { ButtonProps } from "../Button/Button";
import PaymentButton from "./PaymentButton";
import PaymentPolicyLinks, {
  PaymentPolicyHelpPanelContext,
} from "./PaymentPolicyLinks";
import { PaymentFooterWrapper } from "./PaymentButton.styles";

type PaymentFooterProps = ButtonProps & {
  helpPanelContext?: PaymentPolicyHelpPanelContext;
};

const PaymentFooter: React.FC<PaymentFooterProps> = React.memo(
  ({ helpPanelContext, ...buttonProps }) => (
    <PaymentFooterWrapper>
      <PaymentButton {...buttonProps} />
      <PaymentPolicyLinks helpPanelContext={helpPanelContext} />
    </PaymentFooterWrapper>
  ),
);

export default PaymentFooter;
